import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

async function enableMocks(): Promise<void> {
  if (import.meta.env.VITE_ENABLE_MOCKS !== 'true') return;
  const { worker } = await import('./mocks/browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: '/mockServiceWorker.js' },
  });
}

void enableMocks().then(() => {
  const el = document.getElementById('root');
  if (!el) throw new Error('#root element missing from index.html');
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
